export default __webpack_public_path__ + "static/media/img-05.ddf26f2d.jpg";